import React, { FC } from 'react'
import { BaseTextFieldProps, makeStyles, TextField, TextFieldProps } from '@material-ui/core'
import classnames from 'classnames'

interface InputProps extends BaseTextFieldProps {
  hideAsterisk?: boolean
  variant?: TextFieldProps['variant']
  onBlur?: () => void
  onFocus?: () => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onKeyPress?: (e: React.KeyboardEvent) => void
  inputProps?: any
  InputProps?: any
}

export const Input: FC<InputProps> = ({ hideAsterisk, className, variant = 'outlined', InputLabelProps, ...props }) => {
  const classes = useStyles()

  return (
    <TextField
      fullWidth
      className={classnames([classes.input, className || ''])}
      InputLabelProps={{
        shrink: true,
        classes: {
          root: `${classes.inputLabel} MuiInputLabel-shrink`,
          ...(hideAsterisk ? { asterisk: classes.asterisk } : {})
        },
        ...(InputLabelProps ? InputLabelProps : {})
      }}
      variant={variant}
      {...props}
    />
  )
}

const useStyles = makeStyles(() => ({
  input: {
    color: '#000',
    borderRadius: 0,
    minHeight: '42px',
    '& .MuiInputBase-root': {
      height: '42px',
      backgroundColor: '#fff'
    },
    '& .MuiInputBase-root .MuiAutocomplete-input': {
      border: 'none',
      padding: '3px 7px'
    },
    '& fieldset': {
      borderRadius: 0,
      borderColor: '#dadada',
      borderBottomColor: '#000'
    },
    '& textarea.MuiInputBase-input': {
      border: 'none',
      height: '100%'
    },
    '& label.MuiFormLabel-root': {
      color: 'black'
    },
    '& .MuiFormHelperText-root': {
      lineHeight: 1,
      fontSize: '10px'
    },
    '& .MuiInputBase-multiline': {
      height: '100px',
      '& fieldset': {
        top: 0,
        borderBottom: 'none'
      }
    }
  },
  inputLabel: {
    color: 'black',
    '&.Mui-focused': {
      color: 'black'
    }
  },
  asterisk: {
    display: 'none'
  }
}))
